/*
 * @Author: bianbinbin
 * @Date: 2024-03-13 11:18:54
 * @LastEditors: bianbinbin
 * @LastEditTime: 2024-03-13 11:19:17
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/delayReason.js
 */
const delayReason = r => require.ensure([], () => r(require('@/views/delayReason/delayReason.vue'), 'delayReason'))

const router = [
  {
    path: '/delayReason',
    name: 'delayReason',
    meta: {
      title: '延误原因'
    },
    component: delayReason
  }
]

export default router
